import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  CircularProgress
} from '@mui/material';
import './addressvalidationmodal.scss';

type Props = {
  open: boolean;
  loading: boolean;
  enteredView: string[];
  suggestedView?: string[];
  analysis: 'MATCH' | 'NO_MATCH' | string;
  selected: 'entered' | 'suggested';
  onSelect: (sel: 'entered' | 'suggested') => void;
  onAccept: () => void;
  onClose: () => void;
  error?: boolean;
};

const AddressValidationModal: React.FC<Props> = ({
  open,
  loading,
  enteredView,
  suggestedView,
  analysis,
  selected,
  onSelect,
  onAccept,
  onClose,
  error,
}) => {
  const showSelect = analysis === 'MATCH' && !!suggestedView?.length;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" className="addr-modal">
      <DialogTitle>
        {loading ? 'Validating Address...' : error ? "We're Having Trouble" : 'Confirm Address'}
      </DialogTitle>
      <DialogContent dividers>
        {loading && <div className="addr-loading"><CircularProgress /></div>}

        {!loading && showSelect && (
          <RadioGroup
            value={selected}
            onChange={(e) => onSelect(e.target.value as 'entered' | 'suggested')}
            className="addr-radio-group"
          >
            <FormControlLabel
              value="entered"
              control={<Radio />}
              label={
                <div className="addr-box">
                  <div className="addr-title">You Entered:</div>
                  <ul className="addr-lines">
                    {enteredView.map((line, i) => <li key={i}>{line}</li>)}
                  </ul>
                </div>
              }
            />
            <FormControlLabel
              value="suggested"
              control={<Radio />}
              label={
                <div className="addr-box">
                  <div className="addr-title">We Suggest:</div>
                  <ul className="addr-lines">
                    {suggestedView!.map((line, i) => <li key={i}>{line}</li>)}
                  </ul>
                </div>
              }
            />
          </RadioGroup>
        )}

        {!loading && !showSelect && (
          <div>
            <div className="addr-message">
              We were unable to verify your address.<br />
              Please make sure it's correct.
            </div>
            <div className="addr-box">
              <div className="addr-title">You Entered:</div>
              <ul className="addr-lines">
                {enteredView.map((line, i) => <li key={i}>{line}</li>)}
              </ul>
            </div>
          </div>
        )}
      </DialogContent>

      {!loading && (
        <DialogActions className="addr-actions">
          <Button onClick={onClose}>Edit</Button>
          <Button variant="contained" onClick={onAccept}>Use Address</Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default AddressValidationModal;